import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'

const Login = ({login}) => {
  const div = {
    maxWidth: 330,
    padding: 15,
    margin: '0 auto'
  }

  const buttonStyle = {
    marginTop: 20,
    marginBottom: 100
  }

  return (
    <div style={div}>
      <Button
        onClick={login}
        style={buttonStyle}
        >
        Sign in to Diesel
      </Button>
    </div>
  )
}

Login.propTypes = {
  login: PropTypes.func.isRequired
}

export default Login
